import script from "./VerticalPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerticalPanel.vue?vue&type=script&setup=true&lang=ts"

import "./VerticalPanel.vue?vue&type=style&index=0&id=0df70a27&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df70a27"]])

export default __exports__